// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"88":"PokemonList","655":"PokedexPokemon"}[chunkId] + "." + {"88":"107ee794","655":"a2eeced7"}[chunkId] + ".js";
};